<template>
  <div
    :class="[
      'bp1440-w-740 bp1680-w-863 mx-auto mb-10 flex w-full max-w-185 flex-col px-5 md:w-[83%] lg:w-[60.15%] lg:px-0 xl:mb-17.5 xl:w-[65.85%]',
    ]"
  >
    <div
      v-html="code"
      class="w-full [&_iframe]:aspect-video [&_iframe]:h-full [&_iframe]:w-full"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  code: string
  background?: string
}

defineProps<Props>()
</script>
